module.exports = __webpack_public_path__ + "img/sales_volume.9bae7e37.png";